export const useLoadingStore = defineStore('LoadingStore', {
  state: () => {
    return {
      isLoading: false,
      loadingText: '',
      topLoadingText: null
    }
  },
  getters: {},
  actions: {
    startLoading(text = '', topText = null) {
      this.isLoading = true
      this.loadingText = text
      this.topLoadingText = topText
    },
    stopLoading() {
      this.isLoading = false
      this.loadingText = ''
      this.topLoadingText = null
    }
  }
})
